import type { FormattedSelfLimit } from '@library/types/memberResponsibleGaming';

export interface MemberResponsibleGamingSelfLimitRowProps {
  selfLimit: FormattedSelfLimit;
}

export const MemberResponsibleGamingSelfLimitRow = ({
  selfLimit
}: MemberResponsibleGamingSelfLimitRowProps) => {
  const {
    endDate,
    endTime,
    timeRemaining,
    selfLimitType,
    updatedDate,
    updatedTime
  } = selfLimit;

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex h-16 cursor-pointer items-center border-b xl:text-xs"
      data-testid={`member-${selfLimitType}-limit`}
    >
      <p className="flex flex-1 p-3">{selfLimitType}</p>
      <div className="flex flex-1 flex-col p-3">
        <p>{updatedDate}</p>
        <p>{updatedTime}</p>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <p>{endDate}</p>
        <p>{endTime}</p>
      </div>
      <p className="flex flex-1 p-3">{timeRemaining}</p>
    </div>
  );
};
